import React, { useEffect, useState } from "react";
import { Container, Grid, Image, Modal } from "semantic-ui-react";
import cx from "classnames";

import Cancel from "components/ui/Buttons/CancelButton";
import SaveChanges from "components/ui/Buttons/SaveButton";
import DatePicker from "react-datepicker";

import styles from "./styles.module.scss";
import moment from "moment";
import _ from "lodash";
import { uploadOrderForm } from "actions/accounts";
import { useDispatch, useSelector } from "react-redux";

export default function UploadOrderForm(props) {

    const dispatch = useDispatch();
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState("");
    const [date, setDate] = useState("");
    const [dateStr, setDateStr] = useState();
    const [showError, setShowError] = useState(false);
    const [fileData, setFileData] = useState()

    const handleOrderFormUpload = (e) => {
        var file = e.target.files[0];
        setFile(file)
        setFileName(file.name)
        setFileData(file)

    }

    const handleDateChange = (date) => {

        let dateStr = moment(date).format("YYYY-MM-DD");
        setDate(date);
        setDateStr(dateStr);
        setShowError(false);
    };

    const handleClose = () => {
        setFileName("");
        setDate("");
        setDateStr("");
        setShowError(false);
        props.setOpen(false);

    }

    const onSave = () => {

        if (fileData && _.size(dateStr) > 0) {
            const data = {
                id: props.account.id,
                file: fileData,
                date: dateStr,
            }

            dispatch(uploadOrderForm(data))
            setFileName("");
            setFileData("");
            setDate("");
            setDateStr("");
            setShowError(false);
            props.onSave();
            props.setInitialTableRender(false)

        }
        else {
            setShowError(true);
        }
    }

    return (
        <>
            <Modal
                size="tiny"
                open={props.open}
                centered
                onClose={() => handleClose}
                onOpen={() => props.setOpen(true)}
                className={styles.UploadOrderForm}
            >
                <Modal.Header className={styles.modalHeader}>Order Form</Modal.Header>
                <Modal.Content className={cx(styles.content)}>
                    <div className={styles.uploadContainer}>
                        <span className={styles.uploadHeader}> {_.size(fileName) > 0 ? fileName : "Upload / Drag and drop"} </span>
                        <input type="file" className={styles.orderFormUploadIcon}
                            onChange={handleOrderFormUpload}
                        ></input>
                    </div>


                    <div className={styles.dateContainer}>
                        <span className={styles.dateHeader}>Select date</span>
                        <DatePicker
                            selected={date}
                            placeholderText="dd-mm-yyyy"
                            onChange={handleDateChange}
                            maxDate={new Date()}
                            className={cx(styles.date)}
                            dateFormat={"dd-MM-yyyy"}
                            showYearDropdown={true}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            popperClassName={styles.random}
                            popperPlacement="top-start"
                        />
                        <br />
                        {showError && <span className={styles.errorContainer}>Please select all fields</span>}
                    </div>

                    <Container className={cx(styles.container)}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column textAlign="center">
                                    <SaveChanges content="Upload" onClick={onSave} />
                                    <Cancel content="Cancel" onClick={handleClose} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </Modal.Content>
            </Modal>
        </>
    );
}
